/**
 * Blue Zone Introbox Modal - Bootstrap Script
 * Global trigger listener and modal loader
 */

(function() {
  'use strict';
  
  let modalLoaded = false;
  let modalScriptsLoaded = false;
  
  /**
   * Load the main modal bundle and dependencies
   */
  function loadIntroboxModal() {
    if (modalLoaded) {
      window.IntroboxModal.open().catch(error => {
        console.warn('Failed to open Introbox modal:', error);
      });
      return;
    }
    
    if (modalScriptsLoaded) return;
    modalScriptsLoaded = true;
    
    // Load CSS first (use URLs provided by theme for preview/live correctness)
    const cssUrl = (window.IntroboxAssetUrls && window.IntroboxAssetUrls.css) || '/assets/introbox-modal.css';
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
    
    // Load scripts sequentially to ensure proper dependency order
    const scriptsToLoad = (window.IntroboxAssetUrls && window.IntroboxAssetUrls.scripts) || [
      '/assets/introbox-calculations.js',
      '/assets/introbox-analytics.js',
      '/assets/introbox-cart-handler.js',
      '/assets/introbox-modal.js'
    ];
    
    let currentScriptIndex = 0;
    
    function loadNextScript() {
      if (currentScriptIndex >= scriptsToLoad.length) {
        // All scripts loaded, initialize modal
        modalLoaded = true;
        window.IntroboxModal.init();
        // Ensure modal becomes visible when JS is ready
        const root = document.getElementById('introbox-modal');
        if (root) root.style.display = '';
        window.IntroboxModal.open().catch(error => {
          console.warn('Failed to open Introbox modal:', error);
        });
        return;
      }
      
      const script = document.createElement('script');
      script.src = scriptsToLoad[currentScriptIndex];
      script.onload = () => {
        currentScriptIndex++;
        loadNextScript();
      };
      script.onerror = () => {
        // Failed to load Introbox script - silent fail for production
        // console.error('Failed to load Introbox script:', scriptsToLoad[currentScriptIndex]);
        currentScriptIndex++;
        loadNextScript();
      };
      document.head.appendChild(script);
    }
    
    loadNextScript();
  }
  
  /**
   * Handle trigger clicks
   */
  function handleTriggerClick(e) {
    const target = e.target.closest('a[href="#bluezone-introbox"]');
    if (!target) return;
    
    e.preventDefault();
    
    // Track analytics for trigger source
    const source = target.textContent.trim() || target.getAttribute('aria-label') || 'unknown_trigger';
    
    // Apply discount code to URL if not already present
    if (!window.location.search.includes('discount=')) {
      const newUrl = window.location.pathname + '?discount=INTROBOX25' + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
    
    // Load and open modal
    loadIntroboxModal();
    
    // Track analytics after modal opens
    setTimeout(() => {
      if (window.IntroboxAnalytics) {
        window.IntroboxAnalytics.trackFlowOpen(source, window.location.href);
      }
    }, 100);
  }
  
  /**
   * Setup global event listeners
   */
  function setupEventListeners() {
    // Listen for trigger clicks
    document.addEventListener('click', handleTriggerClick, true);
    
    // Listen for hash changes (in case someone navigates to #bluezone-introbox)
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#bluezone-introbox') {
        loadIntroboxModal();
      }
    });
    
    // Check if page was loaded with hash
    if (window.location.hash === '#bluezone-introbox') {
      loadIntroboxModal();
    }
  }
  
  /**
   * Initialize bootstrap when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEventListeners);
    } else {
      setupEventListeners();
    }
  }
  
  // Initialize
  init();
  
})();
